import { Button as BootstrapButton, ButtonProps as BootstrapButtonProps } from "react-bootstrap"

export interface ButtonProps extends BootstrapButtonProps {
    loading?:     boolean;
    loadingText?: string;
}

export function Button( props: ButtonProps ) {
    const { loading = false, children, className, loadingText = "Loading...", style, disabled, ...rest } = { ...props };
    const newClassName = `rounded-4 border-primary border-2 status-btn text-black ${className}`;
    return <BootstrapButton variant="body-secondary" className={newClassName} style={{ ...style, opacity: "1" }} disabled={loading || !!disabled} {...rest}>
        {loading ? <>
            <span className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"></span>
            {loadingText}
        </> : children}
    </BootstrapButton>
}